var _style, _path, _circle, _path2, _path3, _path4, _circle2, _circle3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVitaminsAndMinerals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4 113.4",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFC260;}\n\t.st1{fill:#AA1A18;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:0.6593;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:1.3186;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,109.4c29.4,0,53.2-23.6,53.2-52.7S86,4,56.6,4S3.5,27.6,3.5,56.7S27.3,109.4,56.6,109.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 45.5,
    cy: 62.9,
    r: 3.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.4,50.2L67,35.7c0,0,6.4-10.7,17.9-3.9s4,17.8,4,17.8L80.3,64L58,50.8L58.4,50.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85,36.7c0,0,4.3,3.7,1,10.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.8,50.2l-8.6-14.4c0,0-6.4-10.7-17.9-3.9s-4,17.8-4,17.8L32.9,64l22.3-13.3L54.8,50.2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 68.6,
    cy: 74.7,
    r: 3.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 57,
    cy: 87.7,
    r: 3.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 58.1,
    y1: 61.8,
    x2: 63.1,
    y2: 66.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 63.1,
    y1: 61.8,
    x2: 58.1,
    y2: 66.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 45.6,
    y1: 73.7,
    x2: 51.3,
    y2: 77.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 50.5,
    y1: 72.8,
    x2: 46.4,
    y2: 78.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitaminsAndMinerals);
export default __webpack_public_path__ + "static/media/Vitamins_and_Minerals.b1e79de4d6e1b6545f39b61404ca1f3c.svg";
export { ForwardRef as ReactComponent };